export const CRAIG_IMAGE_URL = 'pages/about-us/CRAIG_HEADSHOT_dj3ood';
export const JULIE_IMAGE_URL = 'pages/about-us/JULIE_HEADSHOT_au3w5y';
export const THE_COOKS_IMAGE_URL = 'pages/about-us/ABBY_HEADSHOT_oi4t1b';
export const THE_BOYS_IMAGE_URL = 'pages/about-us/IMG_0538_ffauii';

/*
 * Image Alt Text
 */
export const CRAIG_ALT =
  'Craig Hays, founder of Cornerstone Homes in Claremore, Oklahoma';
export const JULIE_ALT =
  'Julie Hays, co-founder of Cornerstone Homes in Claremore, Oklahoma';
export const THE_COOKS_ALT =
  'Abby Cook, lead designer at Cornerstone Homes, specializing in custom home floor plans';
export const THE_BOYS_ALT =
  'Jackson and Devin, Cornerstone Homes Project Superintendents on a job site';

/*
 * Our Team Metadata
 */
export const OUR_TEAM_METADATA_TITLE =
  'Meet Our Team | Family-Owned Custom Home Builder in Claremore, OK | Cornerstone Homes';

export const OUR_TEAM_METADATA_DESC =
  'Meet Craig, Julie, and Abby — the family behind Cornerstone Homes in Claremore, OK. Since 2001, our team has delivered expert custom home building, renovation, and design services across northeastern Oklahoma.';

export const OUR_TEAM_METADATA_KEYWORDS = [
  'family owned home builder Oklahoma',
  'custom home builder Claremore',
  'Cornerstone Homes team',
  'Craig Hays builder',
  'Julie Hays Cornerstone',
  'Abby Cook home designer',
  'home builder Claremore OK',
  'custom home design Oklahoma',
  'family run construction company',
  'northeastern Oklahoma home builder',
];
